import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LazyLogin } from './Pages';
import { ProtectedRoute } from './Pages/ProtectedRoute';
import App from './App';
import { FluentProvider, Theme, webLightTheme } from '@fluentui/react-components';
import { StripeCheckoutForm } from './Service/Stripe/Stripe';

const theme: Theme = {
  ...webLightTheme,
  fontFamilyBase: "'Montserrat', sans-serif",
  colorBrandBackground: '#F60',
  colorBrandBackgroundHover: '#cf5300',
  colorBrandBackgroundPressed: '#cf5300',
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <FluentProvider theme={theme}>
      <Routes>
        <Route path="login" element={<LazyLogin />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <App />
            </ProtectedRoute>
          }
        />
        <Route path="/checkout" element={<StripeCheckoutForm />} />
      </Routes>
    </FluentProvider>
  </BrowserRouter>
);
